import ufeApi from 'services/api/ufeApi';
import cookieUtils from 'utils/Cookies';

// https://jira.sephora.com/wiki/display/ILLUMINATE/Get+Shipping+Addresses+from+Profile+API
function getShippingAddresses(profileId) {
    let url = `/api/users/profiles/${profileId}/addresses`;
    const { enableProfileShippingGroup = false } = Sephora.configurationSettings;

    if (enableProfileShippingGroup && cookieUtils.isRCPShippingAPIEnabled()) {
        url = `/gway/v2/users/profiles/${profileId}/addresses`;
    }

    return ufeApi.makeRequest(url, { method: 'GET' }).then(data => (data.errorCode ? Promise.reject(data) : data));
}

export default getShippingAddresses;
